// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://cdn.cbd.int/vue-multiselect@2.1.6/dist/vue-multiselect.min.css);"]);
// Module
exports.push([module.id, ".fix{padding:0 0 0 0;background-color:#ddd;border-radius:5px;border-color:transparent}.fix.is-invalid{border-color:#dc3545}.fix.is-invalid,.fix.is-valid{border-width:1px;border-style:solid}.fix.is-valid{border-color:#28a745}.option-image{max-height:30px}.filter-label{font-weight:bolder}.option-filter{padding-left:2em}.high-light{font-weight:900}", ""]);
// Exports
module.exports = exports;
